import {kGlossaryTexts} from "../../../constants/texts";
import GlossaryDetailedSubHeaderButton from "../../buttons/glossaryScreen/GlossaryDetailedSubHeaderButton";
import GlossaryDetailedScreenSubHeaderHighlighter from "./GlossaryDetailedScreenSubHeaderHighlighter";

export default function GlossaryDetailedScreenSubHeader({ currentTab, onTabPressed }) {
    // Used in GlossaryDetailedScreen to display sub header for either Term definition
    // or context display

    // PROPERTIES
    const subTabs = [
        {
            label: kGlossaryTexts.definition,
            value: kGlossaryTexts.definitionTab,
        },
        {
            label: kGlossaryTexts.context,
            value: kGlossaryTexts.contextTab,
        }
    ]

    // BUILD
    return (
        <div className={"w-full px-[16px] pt-[16px]"}>
            <div className="relative flex w-full py-[4px] bg-transparent rounded-[8px] border-[1px] border-greenStar overflow-hidden">
                {/** HIGHLIGHTER */}
                <GlossaryDetailedScreenSubHeaderHighlighter currentTab={currentTab} />
                {/** TABS */}
                {subTabs.map((subTab, index) => (
                        <GlossaryDetailedSubHeaderButton key={index}
                                                         text={subTab.label}
                                                         onButtonPressed={() => onTabPressed(subTab.value)}
                                                         isSelected={currentTab === subTab.value} />
                ))}
            </div>
        </div>

    );
}